import { useMemo } from "react";
import { Table } from "antd";

import { createColumns } from "./tableConfig.js";

/**
 * Компонент таблицы уведомлений
 * @param {Array} data - Данные для отображения в таблице
 * @param {Object} pagination - Настройки пагинации
 * @param {Array} selectedRowKeys - Ключи выбранных строк
 * @param {Function} onRowsSelect - Обработчик выбора строк
 * @param {Function} onReadNotice - Обработчик пометки уведомления как прочитанного
 * @param {Function} onUnreadNotice - Обработчик пометки уведомления как непрочитанного
 * @param {Object} scroll - Настройки скролла таблицы
 */
const NoticesTable = ({
  data,
  pagination,
  selectedRowKeys,
  onRowsSelect,
  onReadNotice,
  onUnreadNotice,
  scroll = { x: "100%" },
}) => {
  // Мемоизированные колонки таблицы
  const columns = useMemo(
    () => createColumns(onUnreadNotice, onReadNotice),
    [onUnreadNotice, onReadNotice]
  );

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      pagination={pagination}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
      tableLayout="fixed"
      bordered
      rowSelection={{
        type: "checkbox",
        hideSelectAll: true,
        selectedRowKeys: selectedRowKeys,
        preserveSelectedRowKeys: true,
        onSelect: onRowsSelect,
      }}
      rowClassName="top-align"
    />
  );
};

export default NoticesTable;
